var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.998 439.398L134.6 442c.11.11.11.288 0 .398l-6.3 6.301-2.676.297a.561.561 0 01-.62-.62l.297-2.677 6.3-6.301c.109-.11.288-.11.397 0zm4.673-.661l-1.407-1.408a1.128 1.128 0 00-1.593 0l-1.02 1.021a.282.282 0 000 .398l2.601 2.603c.11.11.288.11.398 0l1.021-1.022a1.129 1.129 0 000-1.592z",
    id: "tru-edit-pen-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tru-edit-pen-a",
    transform: "translate(-125 -437)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default ForwardRef;